// ----------------------------------------------------------------------

export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

interface responsiveFontSizesInterface {
  sm: number;
  md: number;
  lg: number;
  xl: number;
}

export function responsiveFontSizes(size: responsiveFontSizesInterface) {
  return {
    "@media (min-width:600px)": {
      fontSize: pxToRem(size.sm),
    },
    "@media (min-width:900px)": {
      fontSize: pxToRem(size.md),
    },
    "@media (min-width:1200px)": {
      fontSize: pxToRem(size.lg),
    },
    "@media (min-width:1440px)": {
      fontSize: pxToRem(size.xl),
    },
  };
}

export const primaryFont = "Inter, sans-serif";
export const secondaryFont = "Barlow, sans-serif";

// ----------------------------------------------------------------------

export const typography = {
  fontFamily: primaryFont,
  fontSecondaryFamily: secondaryFont,
  fontWeightThin: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  h1: {
    lineHeight: "140%",
    letterSpacing: "-0.035rem",
    fontSize: pxToRem(28),
    ...responsiveFontSizes({ sm: 20, md: 22, lg: 26, xl: 30 }),
  },
  h2: {
    lineHeight: "140%",
    letterSpacing: "-0.03rem",
    fontSize: pxToRem(24),
    // ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    letterSpacing: "-0.025rem",
    fontSize: pxToRem(20),
    // ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
  },
  h4: {
    letterSpacing: "-0.0225rem",
    fontSize: pxToRem(18),
    // ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
  h5: {
    letterSpacing: "-0.02rem",
    fontSize: pxToRem(16),
    // ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  subtitle1: {
    letterSpacing: "-0.0225rem",
    fontSize: pxToRem(18),
  },
  subtitle2: {
    letterSpacing: "-0.02rem",
    fontSize: pxToRem(16),
  },
  subtitle3: {
    letterSpacing: "-0.0175rem",
    fontSize: pxToRem(14),
  },
  subtitle4: {
    letterSpacing: "-0.01625rem",
    fontSize: pxToRem(13),
  },
  subtitle5: {
    letterSpacing: "-0.015rem",
    fontSize: pxToRem(12),
  },
  // body1: {
  //     lineHeight: 1.5,
  //     fontSize: pxToRem(16),
  // },
  // body2: {
  //     lineHeight: 22 / 14,
  //     fontSize: pxToRem(14),
  // },
  // caption: {
  //     lineHeight: 1.5,
  //     fontSize: pxToRem(12),
  // },
  // overline: {
  //     fontWeight: 700,
  //     lineHeight: 1.5,
  //     fontSize: pxToRem(12),
  //     textTransform: 'uppercase',
  // },
  // button: {
  //     fontWeight: 700,
  //     lineHeight: 24 / 14,
  //     fontSize: pxToRem(14),
  //     textTransform: 'unset',
  // },
};
